/**
 * Fire-and-forget dynamic imports to warm Vite route chunks (paths must match App.jsx lazy imports).
 */
export function prefetchRouteChunk(pathname) {
  if (!pathname || typeof pathname !== 'string') return
  const raw = pathname.split('?')[0] || ''
  const p = raw.replace(/\/$/, '') || '/'

  const go = (importer) => {
    try {
      void importer()
    } catch (_) {
      /* ignore */
    }
  }

  if (p === '/dashboard') go(() => import('../pages/HomeDashboard'))
  else if (p === '/stock/dashboard') go(() => import('../pages/Dashboard'))
  else if (p === '/stock' || /^\/stock\/\d+$/.test(p)) go(() => import('../pages/Stock'))
  else if (p === '/suppliers') go(() => import('../pages/Suppliers'))
  else if (p === '/movements') go(() => import('../pages/Movements'))
  else if (p === '/alerts') go(() => import('../pages/Alerts'))
  else if (p === '/users') go(() => import('../pages/UserManagement'))
  else if (/^\/users\/\d+$/.test(p)) go(() => import('../pages/UserDetail'))
  else if (p === '/material-requests') go(() => import('../pages/AdminMaterialRequests'))
  else if (p === '/monthly-restocks') go(() => import('../pages/MonthlyRestocks'))
  else if (p === '/purchase-orders') go(() => import('../pages/PurchaseOrders'))
  else if (p === '/jobs/dashboard') go(() => import('../pages/jobs/JobsDashboard'))
  else if (/^\/jobs\/clients\/\d+$/.test(p)) go(() => import('../pages/jobs/ClientDetail'))
  else if (p === '/jobs/clients') go(() => import('../pages/jobs/Clients'))
  else if (p === '/jobs/quotations') go(() => import('../pages/jobs/Quotations'))
  else if (p === '/jobs/stock-usage') go(() => import('../pages/jobs/JobsStockUsage'))
  else if (/^\/jobs\/\d+$/.test(p)) go(() => import('../pages/jobs/JobDetail'))
  else if (p === '/jobs') go(() => import('../pages/jobs/Jobs'))
  else if (p === '/painter/dashboard') go(() => import('../pages/PainterDashboard'))
  else if (p === '/painter/stock' || p === '/painter/search') go(() => import('../pages/PainterStockSimple'))
  else if (p === '/painter/record-usage') go(() => import('../pages/PainterRecordUsage'))
  else if (p === '/painter/transfer') go(() => import('../pages/PainterTransfer'))
  else if (p === '/painter/request') go(() => import('../pages/PainterRequest'))
  else if (p === '/painter/monthly-restock') go(() => import('../pages/PainterMonthlyRestock'))
  else if (p === '/painter/monthly-restock/new') go(() => import('../pages/PainterMonthlyRestockForm'))
  else if (p === '/painter/my-requests') go(() => import('../pages/PainterMyRequests'))
  else if (p === '/painter/purchase-orders') go(() => import('../pages/PainterPurchaseOrders'))
  else if (p === '/painter/movements') go(() => import('../pages/PainterMovements'))
  else if (p === '/painter/alerts') go(() => import('../pages/PainterAlerts'))
}
